import React from 'react';
import Typography from '@material-ui/core/Typography';
import { getFormattedPaycodeDuration } from '../Calendar/calendarFunctions';
import { getPaycodeTimePeriod } from '../Utils/uiGenerators';
import { styles } from './paycodeCard.service';

const noop = () => { };

const PaycodeCard = ({
    handleOnClick = noop,
    paycode,
}) => {
    const {
        durationInTime,
        payCodeRef: { qualifier },
    } = paycode;

    const timeRange = getPaycodeTimePeriod(paycode);
    const formattedDuration = getFormattedPaycodeDuration(durationInTime);

    return (
        <div
            style={styles.paycodeCard}
            onClick={handleOnClick}
        >
            <div style={styles.cardTypeContainer}>
                <div style={styles.cardType}>
                    {`${qualifier} [${formattedDuration}]`}
                </div>
            </div>
            <Typography variant={'subtitle1'}>
                {timeRange}
            </Typography>
        </div>
    );
}

export default PaycodeCard;
